import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const {
  sectionAdvantages: { lists, transporter, shipper },
} = dic[LANG]

export const newList = (lists, transporter, shipper) => {
  return [
    {
      id: 1,
      caption: transporter,
      form: 'transporters',
      list: [
        {
          id: 11,
          label: lists.transporter[11].label,
          description: lists.transporter[11].description,
        },
        {
          id: 12,
          label: lists.transporter[12].label,
          description: lists.transporter[12].description,
        },
        {
          id: 13,
          label: lists.transporter[13].label,
          description: lists.transporter[13].description,
        },
        {
          id: 14,
          label: lists.transporter[14].label,
          description: lists.transporter[14].description,
        },
        {
          id: 15,
          label: lists.transporter[15].label,
          description: lists.transporter[15].description,
        },
        {
          id: 16,
          label: lists.transporter[16].label,
          description: lists.transporter[16].description,
        },
      ],
    },
    {
      id: 2,
      caption: shipper,
      form: 'shippers',
      list: [
        {
          label: lists.shipper[21].label,
          description: lists.shipper[21].description,
        },
        {
          label: lists.shipper[22].label,
          description: lists.shipper[22].description,
        },
        {
          label: lists.shipper[23].label,
          description: lists.shipper[23].description,
        },
        {
          label: lists.shipper[24].label,
          description: lists.shipper[24].description,
        },
        {
          label: lists.shipper[25].label,
          description: lists.shipper[25].description,
        },
        {
          label: lists.shipper[26].label,
          description: lists.shipper[26].description,
        },
      ],
    },
  ]
}
export default {
  namespaced: true,
  state: {
    data: newList(lists, transporter, shipper),
  },
}
